document.addEventListener('DOMContentLoaded', function () {
  let cropper;
  let checkImageInterval; // Global interval to prevent race conditions
  const imageDesignWrapper = document.querySelector('[data-image-design]');
  const imageControls = document.querySelector('.image-controls');
  // FIX: Select ALL next step buttons (desktop and mobile)
  const nextStepButtons = document.querySelectorAll('.sp_form-third__wrapper .sp_form__next-step');

  // Helper to clear all image state
  function clearImageState() {
    // 1. Clear localStorage (both standard and prefixed)
    localStorage.removeItem('uploadedImage');
    const accessCode = localStorage.getItem('accessCode');
    if (accessCode) {
      localStorage.removeItem(`${accessCode}_uploadedImage`);
      localStorage.removeItem(`${accessCode}uploadedImage`);
    }
    console.log('[Cropper] Cleared all localStorage image keys');

    // 2. Aggressively wipe DOM
    if (imageDesignWrapper) {
      imageDesignWrapper.innerHTML = '';
      console.log('[Cropper] Wiped imageDesignWrapper innerHTML');
    }

    // 3. Clear file input
    const fileInput = document.querySelector('#input-file');
    if (fileInput) {
      fileInput.value = '';
    }

    // 4. Destroy cropper
    if (cropper) {
      cropper.destroy();
      cropper = null;
    }

    // 5. Stop interval
    if (checkImageInterval) {
      clearInterval(checkImageInterval);
      checkImageInterval = null;
    }
  }

  // Observer to detect when the third step is visible and the image is loaded
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        const thirdStep = document.querySelector('.sp_form-third__wrapper');
        const isVisible = thirdStep && !thirdStep.closest('.js-sp_form_step').classList.contains('d-none');

        if (isVisible) {
          initializeCropper();
        } else {
          destroyCropper();
        }
      }
    });
  });

  const thirdStepSection = document.querySelector('.sp_form-third__wrapper');
  if (thirdStepSection) {
    const stepContainer = thirdStepSection.closest('.js-sp_form_step');
    if (stepContainer) {
      observer.observe(stepContainer, { attributes: true });
    }
  }

  // Observer for Form Second Stage - CLEAR IMAGE whenever this stage becomes visible
  const secondStepObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        const secondStep = document.querySelector('.sp_form-second__wrapper');
        const isVisible = secondStep && !secondStep.closest('.js-sp_form_step').classList.contains('d-none');

        if (isVisible) {
          console.log('[Stage 2] Visible - Executing full cleanup');
          clearImageState();

          // Restore default preview content
          const previewDiv = document.querySelector('.sp_form__file-preview');
          if (previewDiv) {
            const defaultHtml = previewDiv.getAttribute('data-default-html');
            if (defaultHtml) {
              previewDiv.innerHTML = defaultHtml;
            } else {
              previewDiv.innerHTML = '';
            }
            previewDiv.style.border = '';
          }
        }
      }
    });
  });

  const secondStepSection = document.querySelector('.sp_form-second__wrapper');
  if (secondStepSection) {
    const stepContainer = secondStepSection.closest('.js-sp_form_step');
    if (stepContainer) {
      secondStepObserver.observe(stepContainer, { attributes: true });
    }
  }

  function initializeCropper() {
    // Stop any existing interval to prevent duplicates
    if (checkImageInterval) {
      clearInterval(checkImageInterval);
      checkImageInterval = null;
    }

    // DEFENSIVE: Clear any stale uploadedImage from localStorage to ensure fresh start
    // This prevents the original (uncropped) image from persisting if user navigates back
    const existingImage = localStorage.getItem('uploadedImage');
    if (existingImage && !existingImage.includes('data:image')) {
      console.warn('[Cropper] Clearing potentially corrupted uploadedImage from localStorage');
      localStorage.removeItem('uploadedImage');
    }

    // Wait for the image to be added by the existing script AND ensure it's loaded
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds maximum wait

    checkImageInterval = setInterval(() => {
      attempts++;
      const image = imageDesignWrapper.querySelector('img');

      // NEW: Check for broken image immediately (loaded but 0 width)
      if (image && image.complete && image.naturalWidth === 0) {
        clearInterval(checkImageInterval);
        checkImageInterval = null;
        console.error('[Cropper] Detected broken image (width 0)');
        alert('Error: The uploaded file appears to be corrupted or is not a valid image. Please try a different file.');

        // Return to upload page
        const prevBtn = document.querySelector('.sp_form-third__wrapper .sp_form__prev-step');
        if (prevBtn) prevBtn.click();
        return;
      }

      // MOBILE/DESKTOP FIX: Check both that element exists AND image is fully loaded
      // image.complete checks if browser finished loading
      // image.naturalWidth > 0 checks that image has actual dimensions
      let isImageLoaded = image && image.src && (
        image.complete && image.naturalWidth > 0
      );

      // NEW: Fallback for large images that failed to save to localStorage (QuotaExceededError)
      // If we have waited a bit (e.g., 1 second / 10 attempts) and the image is still missing from the DOM,
      // but we have a file in the input, let's inject it directly via URL.createObjectURL.
      if (!image && attempts > 10) {
        const fileInput = document.querySelector('#input-file');
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
          console.warn('[Cropper] Image missing from DOM (likely localStorage quota exceeded). Injecting from file input...');

          const file = fileInput.files[0];
          const objectUrl = URL.createObjectURL(file);

          const img = document.createElement('img');
          img.src = objectUrl;
          img.style.maxWidth = '100%';
          img.style.display = 'block';

          // Clear wrapper and append
          imageDesignWrapper.innerHTML = '';
          imageDesignWrapper.appendChild(img);

          // We'll catch it on the next interval tick
          return;
        }
      }

      if (isImageLoaded) {
        clearInterval(checkImageInterval);
        checkImageInterval = null;
        console.log('[Cropper] Image loaded successfully (attempts: ' + attempts + ')');

        // Remove existing transform styles as Cropper handles it
        image.style.transform = '';
        image.style.left = '';
        image.style.top = '';

        if (cropper) {
          cropper.destroy();
        }

        cropper = new Cropper(image, {
          viewMode: 3, // FILL CONTAINER COMPLETELY
          dragMode: 'move',
          aspectRatio: 1, // FORCE SQUARE CROP BOX (1:1 ratio)
          autoCropArea: 1,
          restore: false,
          modal: true, // SHOW TRANSPARENT OVERLAY
          guides: false,
          center: false,
          highlight: false, // KEEP BLUE OUTLINE HIDDEN
          background: true, // SHOW CHECKERED BACKGROUND
          cropBoxMovable: false,
          cropBoxResizable: false,
          toggleDragModeOnDblclick: false,
          checkOrientation: false, // FIX: Prevent auto-rotation glitch on mobile
          ready() {
            console.log('[Cropper] Ready with 1:1 square aspect ratio');
            startPolling(); // Start polling for remaining uses
          },
        });
      } else if (attempts >= maxAttempts) {
        clearInterval(checkImageInterval);
        checkImageInterval = null;
        console.error('[Cropper] Timeout: Image failed to load after 5 seconds');

        // NEW: User-friendly error and redirect
        alert('Error: Image upload timed out. Please check your internet connection or try a smaller file.');

        const prevBtn = document.querySelector('.sp_form-third__wrapper .sp_form__prev-step');
        if (prevBtn) prevBtn.click();

      } else if (attempts % 10 === 0) {
        // Log progress every 1 second
        console.log('[Cropper] Waiting for image to load... (attempt ' + attempts + '/50)');
      }
    }, 100);
  }

  let pollingInterval;

  function startPolling() {
    if (pollingInterval) clearInterval(pollingInterval);

    const poll = async () => {
      try {
        const accessCode = localStorage.getItem('accessCode');
        if (!accessCode) return;

        const response = await fetch(`https://api.studiosarte.com/api/v1/codes/${accessCode}/check/`);
        if (response.ok) {
          const data = await response.json();
          const uses = data.uses_remaining || 0;

          // Fallback to localStorage for maxUses if not in API response, then default to 3
          const storedMax = localStorage.getItem('maxUses');
          const max = data.max_uses || data.total_uses || (storedMax ? parseInt(storedMax) : 3);

          // Update button text for ALL next step buttons (desktop + mobile)
          const nextStepButtons = document.querySelectorAll('.sp_form-third__wrapper .sp_form__next-step');
          nextStepButtons.forEach(nextBtn => {
            const originalText = nextBtn.dataset.originalText || nextBtn.textContent.replace(/\(\d+\/\d+\)/, '').trim();
            // Ensure we save original text if not already saved
            if (!nextBtn.dataset.originalText) {
              nextBtn.dataset.originalText = originalText;
            }
            nextBtn.textContent = `${originalText} (${uses}/${max})`;

            // Disable if 0 uses
            if (uses <= 0) {
              nextBtn.disabled = true;
              nextBtn.style.opacity = '0.5';
              nextBtn.title = "No generations remaining";
            } else {
              nextBtn.disabled = false;
              nextBtn.style.opacity = '1';
              nextBtn.title = "";
            }
          });
        }
      } catch (e) {
        console.error('[Polling] Error checking uses:', e);
      }
    };

    // Poll immediately then every 15s
    poll();
    pollingInterval = setInterval(poll, 15000);
    console.log('[Polling] Started polling remaining uses');
  }

  function stopPolling() {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
      console.log('[Polling] Stopped polling');
    }
  }

  function destroyCropper() {
    if (cropper) {
      cropper.destroy();
      cropper = null;
    }
    stopPolling();
    // Also stop image checking if we leave the stage
    if (checkImageInterval) {
      clearInterval(checkImageInterval);
      checkImageInterval = null;
    }
  }

  // Handle controls
  if (imageControls) {
    imageControls.addEventListener('click', (e) => {
      if (!cropper) return;

      const button = e.target.closest('button');
      if (!button) return;

      const action = button.getAttribute('data-action');

      switch (action) {
        case 'rotate':
          cropper.rotate(90);
          break;
        case 'zoom-in':
          cropper.zoom(0.1);
          break;
        case 'zoom-out':
          cropper.zoom(-0.1);
          break;
      }
    });
  }

  // CLEAR IMAGE STATE when user clicks Go Back button
  const prevStepButtons = document.querySelectorAll('.sp_form-third__wrapper .sp_form__prev-step');
  prevStepButtons.forEach(button => {
    button.addEventListener('click', () => {
      console.log('[Cropper] Go Back clicked - initiating cleanup');
      clearImageState();

      // Restore default preview content
      const previewDiv = document.querySelector('.sp_form__file-preview');
      if (previewDiv) {
        const defaultHtml = previewDiv.getAttribute('data-default-html');
        if (defaultHtml) {
          previewDiv.innerHTML = defaultHtml;
        } else {
          previewDiv.innerHTML = '';
        }
        previewDiv.style.border = '';
      }
    });
  });

  // Intercept Next Step - Attach to ALL buttons (desktop + mobile)
  if (nextStepButtons.length > 0) {
    nextStepButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (cropper) {
          try {
            // Get cropped canvas with safe dimensions for mobile
            // High-res camera photos can crash mobile browsers if not limited
            const canvas = cropper.getCroppedCanvas({
              maxWidth: 2048,
              maxHeight: 2048,
              fillColor: '#ffffff',
              imageSmoothingEnabled: true,
              imageSmoothingQuality: 'high',
            });

            // DEFENSIVE: Validate canvas was extracted successfully
            if (!canvas) {
              console.error('[Cropper] Failed to extract cropped canvas');
              alert('Error: Could not crop image. Please try a smaller image.');
              e.preventDefault();
              e.stopPropagation();
              return false;
            }

            // Convert to base64 - USE JPEG TO SAVE SPACE
            // PNG at 2048x2048 is too large for localStorage (5MB limit)
            // JPEG at 0.85 quality is much smaller and visually identical for photos
            const croppedImageData = canvas.toDataURL('image/jpeg', 0.85);

            // DEFENSIVE: Validate the cropped data is valid
            if (!croppedImageData || !croppedImageData.startsWith('data:image')) {
              console.error('[Cropper] Invalid cropped image data:', croppedImageData?.substring(0, 50));
              alert('Error: Invalid image data generated.');
              e.preventDefault();
              e.stopPropagation();
              return false;
            }

            // Update localStorage with try-catch for QuotaExceededError
            try {
              // FIX: Use the same key format as form-custom.js (accessCode_uploadedImage)
              // This ensures the cropped image persists if the page is refreshed
              const accessCode = localStorage.getItem('accessCode');
              const storageKey = accessCode ? `${accessCode}_uploadedImage` : 'uploadedImage';

              localStorage.setItem(storageKey, croppedImageData);
              // Also update the unprefixed key just in case other scripts need it
              if (accessCode) {
                localStorage.setItem('uploadedImage', croppedImageData);
              }

              console.log(`[Cropper] Successfully saved cropped image to localStorage (${storageKey})`);
            } catch (storageError) {
              console.warn('[Cropper] LocalStorage quota exceeded. Proceeding with DOM update only.', storageError);
              // We don't alert the user here because the flow might still work via DOM image
            }

            // Update the image source in the DOM so the submission script picks it up
            // The submission script (form-custom.js) reads from localStorage 'uploadedImage' 
            // or the DOM image src. We updated localStorage, let's also update the DOM just in case.
            const image = imageDesignWrapper.querySelector('img');
            if (image) {
              image.src = croppedImageData;
            }
          } catch (error) {
            console.error('[Cropper] Error extracting cropped image:', error);
            alert('Error processing image: ' + error.message);
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        } else {
          console.warn('[Cropper] No cropper instance available when Next Step clicked');
        }
      });
    });
  }

  // DEFENSIVE: Save cropped image before user navigates away
  // This ensures the cropped image is persisted even if the user refreshes or closes the tab
  window.addEventListener('beforeunload', () => {
    if (cropper) {
      try {
        const canvas = cropper.getCroppedCanvas();
        if (canvas) {
          const croppedImageData = canvas.toDataURL('image/png');
          if (croppedImageData && croppedImageData.startsWith('data:image')) {
            localStorage.setItem('uploadedImage', croppedImageData);
            console.log('[Cropper] Saved cropped image before page unload');
          }
        }
      } catch (error) {
        console.error('[Cropper] Error saving image before unload:', error);
      }
    }
  });

  // NEW: Immediate cleanup when a new file is selected
  // This prevents "ghost" images or white screens by ensuring the previous state is wiped
  // BEFORE the new image is processed by the main form script.
  const fileInput = document.querySelector('#input-file');
  if (fileInput) {
    fileInput.addEventListener('click', () => {
      // Clear value on click to allow re-selecting the same file
      fileInput.value = '';
    });

    fileInput.addEventListener('change', () => {
      console.log('[Cropper] New file selected - wiping previous state');
      clearImageState();
    });
  }
});
